module.exports = __webpack_public_path__ + "static/media/wmTrial-numbers-2.8edd3f6a.mp3";